import { Injectable, inject } from '@angular/core';
import { CasesState } from '../../states/cases.state';

/**
 * Clear Attachments Use Case
 * Clears attachments from state (used when navigating between cases)
 */
@Injectable({ providedIn: 'root' })
export class ClearAttachmentsUseCase {
  private readonly _state = inject(CasesState);

  public execute(): void {
    this._state.setAttachments([]);
  }
}
